import angular from "angular";

let mod = angular
    .module('BookingModule.DuplicatedTickets', [])
    .component('duplicatedTickets', {
        controller: ['$http', controller],
        template: require('./duplicated-tickets.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.routes = $ctrl.resolve.routes;
        $ctrl.tickets = $ctrl.resolve.tickets;
        $ctrl.passengers = $ctrl.resolve.passengers;
    };

    $ctrl.continueBook = function () {

        if ($ctrl.loading) {
            return;
        }

        $ctrl.loading = true;

        $http
            .post('/save-duplicate-agree', {tickets: $ctrl.tickets})
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.close();
                },
                function (error) {
                    $ctrl.loading = false;
                    $ctrl.close();
                }
            );
    };
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/booking-module/duplicated-tickets/duplicated-tickets.js